const PENDING_SEARCH_ROUTE_ANNOUNCEMENT_KEY = 'pending-search-route-announcement';
const LAST_SEARCH_ROUTE_ANNOUNCEMENT_KEY = 'last-search-route-announcement';

const getSessionStorage = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

export const setPendingSearchRouteAnnouncement = (message: string) => {
  const storage = getSessionStorage();
  if (!storage || !message) {
    return;
  }

  storage.setItem(PENDING_SEARCH_ROUTE_ANNOUNCEMENT_KEY, message);
};

export const peekPendingSearchRouteAnnouncement = () => {
  const storage = getSessionStorage();
  if (!storage) {
    return null;
  }

  return storage.getItem(PENDING_SEARCH_ROUTE_ANNOUNCEMENT_KEY);
};

export const hasPendingSearchRouteAnnouncement = (message: string) => {
  const storage = getSessionStorage();
  if (!storage || !message) {
    return false;
  }

  return storage.getItem(PENDING_SEARCH_ROUTE_ANNOUNCEMENT_KEY) === message;
};

export const clearPendingSearchRouteAnnouncement = () => {
  const storage = getSessionStorage();
  if (!storage) {
    return;
  }

  storage.removeItem(PENDING_SEARCH_ROUTE_ANNOUNCEMENT_KEY);
};

export const consumePendingSearchRouteAnnouncement = (message: string) => {
  const storage = getSessionStorage();
  if (!storage || !message) {
    return false;
  }

  const pendingMessage = storage.getItem(PENDING_SEARCH_ROUTE_ANNOUNCEMENT_KEY);
  if (pendingMessage !== message) {
    return false;
  }

  storage.removeItem(PENDING_SEARCH_ROUTE_ANNOUNCEMENT_KEY);
  return true;
};

export const rememberSearchRouteAnnouncement = (message: string) => {
  const storage = getSessionStorage();
  if (!storage || !message) {
    return;
  }

  storage.setItem(LAST_SEARCH_ROUTE_ANNOUNCEMENT_KEY, message);
};

export const consumeRememberedSearchRouteAnnouncement = (message: string) => {
  const storage = getSessionStorage();
  if (!storage || !message) {
    return false;
  }

  const rememberedMessage = storage.getItem(LAST_SEARCH_ROUTE_ANNOUNCEMENT_KEY);
  if (rememberedMessage !== message) {
    return false;
  }

  storage.removeItem(LAST_SEARCH_ROUTE_ANNOUNCEMENT_KEY);
  return true;
};
